<script>
import { watch, onMounted, onUnmounted } from '@vue/composition-api'

export default {
  name: 'TrailBodyBackground',
  props: {
    background: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const originalBackground = document.body.style.background

    const setBackground = (bg) => {
      document.body.style.background = bg
    }

    onMounted(() => {
      setBackground(props.background)
    })

    watch(() => props.background, (newBg) => {
      setBackground(newBg)
    })

    onUnmounted(() => {
      document.body.style.background = originalBackground
    })
  }
}
</script>